export const ROOT = '/';
export const PRODUCT = '/product';
export const SERVICE = '/service';
export const CONTACT = '/contact';